import { FormInputRow } from 'components/input';
import React, { ChangeEvent, useEffect } from 'react';
import { useAllImagingSettings, useFetchAllImagingSettings } from 'redux/hooks/common';
import { getAllScoreGroups } from 'utils/Global';
import { ImageWellScoresAutoScore } from '.';
import { FMLX_SCORE_GROUP } from 'components/main/constants';

interface Props {
  handleSelectionChange: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  scoringOptionSelectedState: ImageWellScoresAutoScore;
}

const ScoringOptionSelector = (props: Props) => {
  const { scoringOptionSelectedState, handleSelectionChange } = props;
  const fetchAllImagingSettings = useFetchAllImagingSettings();

  useEffect(() => {
    fetchAllImagingSettings();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchAllImagingSettings();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const allImagingSettingProfiles = useAllImagingSettings().captureProfileRows.map(
    (x) => ({ title: x.name, value: x.id }),
  );

  /**
   * Filter score groups that are auto score and are not unit score and are not inherit
   * This filter  is temporary, we need to have a simple auto socre flag for these type of groups.
   *
   */
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  const scoreGroups = getAllScoreGroups()
    .filter(
      (x) =>
        x.isAutoScore &&
        x.unit == null &&
        x.isInherit == false &&
        x.scoreGroupType == 0 &&
        !x.name.equalsIgnoreCase(FMLX_SCORE_GROUP),
    )
    .map((x) => ({ title: x.name, value: x.scoreGroupsId }))
    .sort((a, b) => collator.compare(a.title, b.title));

  return (
    <div id="scoringoptionselector-wrapper">
      <FormInputRow
        id={`scoringoptionselector-scoregroup-input`}
        labeltext="Score"
        inputType="select"
        options={scoreGroups}
        value={scoringOptionSelectedState.scoreGroup}
        name="scoreGroup"
        onChange={handleSelectionChange}
      />
      <FormInputRow
        id={`scoringoptionselector-imagesettings-input`}
        labeltext="Image Settings"
        inputType="select"
        options={allImagingSettingProfiles}
        value={scoringOptionSelectedState.imageSettings}
        name="imageSettings"
        onChange={handleSelectionChange}
      />
    </div>
  );
};

export default ScoringOptionSelector;
